import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  block-size: ${spacing(35)}; // 280px
  inline-size: 100%;
  max-inline-size: ${spacing(56)}; // 448px
`
export const iconSpot = css`
  align-items: center;
  background-color: ${cssTheme.default.day.backgroundMinor};
  block-size: ${spacing(5)}; // 40px
  border-radius: 50%;
  display: flex;
  inline-size: ${spacing(5)}; // 40px
  justify-content: center;
  margin-inline-start: ${spacing(-2)}; // -16px
`

export const slotWrapper = css`
  padding-block: ${spacing(1)}; // 8px
`
